<template>
  <div class="audio-library-table">
    <div v-for="(row) in rows" :key="`audio-library-table__rows-list--${row.uuid}`" class="audio-library-table__row">
      <NuxtLink :to="row.path.alias" class="audio-library-table__row-link">
        <div v-if="row.mediaLibrary" class="audio-library-table__cell audio-library-table__cell--play">
          <Icon name="PlayTiny" />
        </div>
        <div class="audio-library-table__cell">
          {{ useFormatDate('fullDate', useFormatDate('utc', row.fieldDate.start)) }}
        </div>
        <div class="audio-library-table__cell audio-library-table__cell--time">
          {{ `${useFormatDate('time', useFormatDate('utc', row.fieldDate.start))} – ${row.fieldDate.end.length ? useFormatDate('time', useFormatDate('utc', row.fieldDate.end)) : ''} ` }}
        </div>
        <div class="audio-library-table__cell">
          {{ row.title }}
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">

const props = defineProps<{
  rows: any[]
}>()

const filteredrows = computed(() => {
  return props.episodes.filter((episode) => {
    return episode !== null
  })
})

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.audio-library-table {
  &__row {
    border-top: var(--border);

    &:last-child {
      border-bottom: var(--border);
    }
  }

  &__row-link { // stylelint-disable-line
    @include tools.table-row;
    border-top: 0;
    border-bottom: 0;

    &:last-child {
      border-bottom: 0;
    }
  }

  &__cell {
    @include tools.table-cell;

    &--play {
      display: flex;
      align-items: center;
      width: var(--space--sm);
    }

    &--time {
      word-spacing: -0.125em;
      @include tools.to(tools.$breakpoint--desktop) {
        grid-column: span 2;
      }
    }
  }
}

</style>
